import $ from 'jquery';

$(function () {
  var hexToRgb;
  var updateColorPreview;
  var getSecondaryColor;
  var updateSecondaryColor;

  var $primaryColorInput = $('.primary-color-input');

  if ($primaryColorInput.length) {
    // adapted from http://jsfiddle.net/subodhghulaxe/t568u/
    hexToRgb = function (hex) {
      hex = hex.replace('#', '');
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);

      return [r, g, b];
    };

    // adapted from http://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
    getSecondaryColor = function (primaryRgbArray) {
      var r = primaryRgbArray[0],
        g = primaryRgbArray[1],
        b = primaryRgbArray[2];

      if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
        return '#000000';
      } else {
        return '#ffffff';
      }
    };

    updateColorPreview = function (primaryColor, id) {
      $('.primary-color-preview[data-branding="' + id + '"]').css(
        'background',
        primaryColor,
      );
    };

    updateSecondaryColor = function (primaryColor, id) {
      var secondaryColor = getSecondaryColor(hexToRgb(primaryColor));
      $('.secondary-color-input[data-branding="' + id + '"]').val(
        secondaryColor,
      );
    };

    $primaryColorInput.change(function () {
      var primaryColor = this.value;
      var brandingId = this.dataset.branding;
      if (primaryColor.match(this.pattern)) {
        updateColorPreview(primaryColor, brandingId);
        updateSecondaryColor(primaryColor, brandingId);
      }
    });

    $primaryColorInput.each(function () {
      var primaryColor = this.value;
      var brandingId = this.dataset.branding;

      updateColorPreview(primaryColor, brandingId);
      var secondaryColorInput = $(
        '.secondary-color-input[data-branding="' + brandingId + '"]',
      );
      if (!secondaryColorInput.value) {
        updateSecondaryColor(primaryColor);
      }
    });
  }
});
